import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SiteContentWrapper, Container, Row, Col } from '@luigiclaudio/ga-baseline-ui/layout';
import { buttonBtnTypeData, buttonSkinData } from '@luigiclaudio/ga-baseline-ui/button';
import { H1, H3 } from '@luigiclaudio/ga-baseline-ui/typography';
import MailchimpSubscribeForm from '../MailchimpSubscribeForm';
import MailchimpSubscribeFeatureDescription from './MailchimpSubscribeFeatureDescription';
import MailchimpSubscribeFormContainer from './MailchimpSubscribeFormContainer';
import FeatureContainer from './FeatureContainer';

var MailchimpSubscribeFeature = function MailchimpSubscribeFeature(_ref) {
  var baseUrl = _ref.baseUrl,
      u = _ref.u,
      id = _ref.id,
      buttonBtnType = _ref.buttonBtnType,
      buttonSkin = _ref.buttonSkin,
      verticalSpacing = _ref.verticalSpacing,
      showDivider = _ref.showDivider;
  return /*#__PURE__*/React.createElement(FeatureContainer, {
    verticalSpacing: verticalSpacing,
    showDivider: showDivider
  }, /*#__PURE__*/React.createElement(SiteContentWrapper, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Col, {
    xxs: 28,
    md: 14,
    lg: 12,
    xl: 10
  }, /*#__PURE__*/React.createElement(MailchimpSubscribeFeatureDescription, null, /*#__PURE__*/React.createElement(H1, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "mailchimpSubscribe.feature.title"
  })), /*#__PURE__*/React.createElement(H3, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "mailchimpSubscribe.feature.subtitle"
  })))), /*#__PURE__*/React.createElement(Col, {
    xxs: 28,
    md: 14,
    lg: 12,
    xl: 10
  }, /*#__PURE__*/React.createElement(MailchimpSubscribeFormContainer, null, /*#__PURE__*/React.createElement(MailchimpSubscribeForm, {
    baseUrl: baseUrl,
    u: u,
    id: id,
    buttonBtnType: buttonBtnType,
    buttonSkin: buttonSkin
  })))))));
};

MailchimpSubscribeFeature.defaultProps = {
  buttonSkin: undefined,
  buttonBtnType: undefined,
  verticalSpacing: 8,
  showDivider: false
};
export default MailchimpSubscribeFeature;